import { useState } from 'react';

function useToggle(initial = false) {
  const [toggle, setToggle] = useState(initial);

  function onToggle() {
    setToggle(!toggle);
  }

  return [toggle, onToggle];
}

export default useToggle;
